var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75H12.75V10.75H15.75V9.25H12.75V6.25H11.25V9.25H8.25V10.75H11.25V13.75ZM12 21.5095C9.48333 19.3288 7.59617 17.2994 6.3385 15.4212C5.08083 13.5429 4.452 11.8185 4.452 10.248C4.452 7.94033 5.19842 6.07208 6.69125 4.64325C8.18425 3.21442 9.95383 2.5 12 2.5C14.0462 2.5 15.8157 3.21442 17.3087 4.64325C18.8016 6.07208 19.548 7.94033 19.548 10.248C19.548 11.8185 18.9192 13.5429 17.6615 15.4212C16.4038 17.2994 14.5167 19.3288 12 21.5095Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopsActive);
export default __webpack_public_path__ + "static/media/stops-active.dc8d8fc7f893a37f65ef0b98ac511e51.svg";
export { ForwardRef as ReactComponent };